import { useRouter } from 'next/router';

export default function PostDivWrapper({
  children,
  widthClassname = '',
  customClassname,
}: {
  widthClassname?: string;
  customClassname?: string;
  children?: React.ReactNode | React.ReactNode[];
}) {
  const router = useRouter();
  const { gid } = router.query;

  return (
    <>
      <div className="w-full bg-transparent">
        <div
          className={`m-[15px_14px] bg-white shadow-[0px_4px_20px_rgba(0,0,0,0.1)] ${
            gid ? '-mx-2 md:m-[15px_14px]' : ''
          } rounded-lg ${widthClassname || ''} ${customClassname || ''}`}
        >
          {children}
        </div>
      </div>
    </>
  );
}
